import React from 'react';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import TextField from '@mui/material/TextField';

function Preparation({ index, data, setData }) {
  const handleChange = (e) => {
    const newData = [...data];
    newData[index] = {
      ...newData[index],
      [e.target.name]: e.target.value,
    };
    setData(newData);
  };

  return (
    <div>
      {/* Preparation Question */}
      <FormControl fullWidth sx={{ mb: 2, mt: 2 }}>
        <InputLabel id="preparationLabel">
          Do you need special preparation before the first intervention of animals?
        </InputLabel>
        <Select
          name="preparation"
          id="preparation"
          label="Do you need special preparation before the first intervention of animals?"
          value={data[index].preparation || ''}
          onChange={handleChange}
        >
          <MenuItem value="no_preparation">No special preparation</MenuItem>
          <MenuItem value="special_diet">Special diet</MenuItem>
          <MenuItem value="food_restriction">Food restriction</MenuItem>
          <MenuItem value="water_restriction">Water restriction</MenuItem>
          <MenuItem value="antibiotics_treatment">Antibiotics treatment in water</MenuItem>
          <MenuItem value="tamoxifen_treatment">Tamoxifen treatment in food/gels</MenuItem>
          <MenuItem value="other_preparation">Other special preparation</MenuItem>
        </Select>
      </FormControl>

      {/* Show preparation days only when something is selected */}
      {data[index].preparation &&
        data[index].preparation !== 'no_preparation' && (
          <TextField
            id="preparationDays"
            name="preparationDays"
            label="For how many days?"
            variant="outlined"
            fullWidth
            sx={{ mb: 2 }}
            value={data[index].preparationDays || ''}
            onChange={handleChange}
          />
        )}

      <TextField
        id="cohorts"
        name="cohorts"
        label="How many cohorts will undergo this experiment?"
        variant="outlined"
        fullWidth
        sx={{ mb: 2 }}
        value={data[index].cohorts || ''}
        onChange={handleChange}
      />

      <TextField
        id="repetitions"
        name="repetitions"
        label="How many times will this experiment be repeated?"
        variant="outlined"
        fullWidth
        sx={{ mb: 2 }}
        value={data[index].repetitions || ''}
        onChange={handleChange}
      />
    </div>
  );
}

export default Preparation;
